import React, { forwardRef, useId } from 'react'
import classes from './styles.module.scss'

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  htmlFor?: string
  label?: string | React.ReactNode
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>((props, ref) => {
  const uniqueId = useId();
  const { className, disabled, htmlFor, label, id, ...rest } = props
  const checkboxId = id || htmlFor || `checkbox-${uniqueId}`

  return (
    <label className={`${classes.checkbox} ${disabled ? classes['checkbox--disabled'] : ''}`} htmlFor={checkboxId}>
      <input
        type='checkbox'
        ref={ref}
        id={checkboxId}
        {...rest}
      />
      <span className={classes.checkmark}></span>
      {label && <span className={classes.label}>{label}</span>}
    </label>

  )
})

Checkbox.displayName = 'Checkbox'